import React from 'react';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

export default function CardDate({ className, dateString, locale }) {
  if (!dateString) {
    return null;
  }
  const dateObj = new Date(dateString);
  return (
    <span className={`${className} ${StringConstantsMixin.constants.XLATE.NONE}`}>
      {dateObj.toLocaleDateString(locale || 'en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
    </span>
  );
}
